module.exports = __webpack_public_path__ + "static/media/paymentConsole.64386e94.png";